export default {
  workstation: {
    tabs: {
      workstation: "Área de trabajo",
      trend: "Tendencia",
    },
    filters: {
      with: "Con",
      without: "Sin",
      splits: "Divisiones",
      none: "Ninguno",
    },
    sections: {
      gamelog: "Registro de partidos",
    },
    headers: {
      line: "Línea",
      opponent: "Rival",
    },
    labels: {
      averagePerGame: "Promedio por partido",
      cover: "Cubrir",
    },
  },
};